import React from 'react';
import ReportingStaffingPage from '../components/ReportingStaffingPage';

const ReportingStaffingApp = (props) => (
  <ReportingStaffingPage {...props} />
);

export default ReportingStaffingApp;
